//const API_WEATHER = 'https://api.openweathermap.org/data/2.5/weather?q=Porto&appid=ee5b838aaeaf6c10ac0ace722104dd82'
const API_NEARCODE = 'https://api.nearcodeconsulting.com/'
/* const API_NEARCODE = 'http://v2.nearcodeconsulting.com/' */
export default API_NEARCODE
